import wretch from 'wretch';
import * as v from 'valibot';
import { FilterSchema } from '../io/filters.io';
import { CategorySchema } from '../io/categories.io';
import { localizedErrorHandlers } from '@fe-core';

const GetFiltersResponseSchema = v.object({
  categories: v.array(CategorySchema),
  filters: v.array(FilterSchema),
});

export type TFiltersResponse = {
  categories: v.Output<typeof CategorySchema>[];
  filters: v.Output<typeof FilterSchema>[];
};

export const getFilters = async ({
  baseUrl,
}: {
  baseUrl: string;
}): Promise<TFiltersResponse> => {
  const url = `${baseUrl}/cat/data`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(GetFiltersResponseSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-catalog | getFilters | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid getSessions response');
    }
  });
};
